export default {
  CHANGE_LOCALE_START: '[intl] Locale change [Start]',
  CHANGE_LOCALE_ERROR: '[intl] Locale change [Error]',
  CHANGE_LOCALE_SUCCESS: '[intl] Locale change [Success]',
  SET_INITIAL_LOCALE: '[intl] Set initial locale',
};